"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CardHeader", {
    enumerable: true,
    get: function() {
        return CardHeader;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _Theme = require("../../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const CardHeader = (param)=>{
    let { children, background, ...props } = param;
    const { colors, spacers } = (0, _Theme.useTheme)();
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        ...props,
        className: _style.default.dynamic([
            [
                "ae1f1891f89362db",
                [
                    colors.border,
                    spacers.s2,
                    spacers.s3,
                    background !== null && background !== void 0 ? background : "none"
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || "")
    }, children), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "ae1f1891f89362db",
        dynamic: [
            colors.border,
            spacers.s2,
            spacers.s3,
            background !== null && background !== void 0 ? background : "none"
        ]
    }, "div.__jsx-style-dynamic-selector{border-bottom:solid 1px ".concat(colors.border, ";padding:").concat(spacers.s2, " ").concat(spacers.s3, ";background:").concat(background !== null && background !== void 0 ? background : "none", "}")));
};

//# sourceMappingURL=CardHeader.js.map